import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'tx-form-field-information-dialog',
  templateUrl: './form-field-information-dialog.component.html',
  styleUrls: ['./form-field-information-dialog.component.scss'],
})
export class FormFieldInformationDialogComponent implements OnInit {
  modal: HTMLElement | null | undefined;
  mainCanvas: HTMLElement | null | undefined;
  fieldNavigatorSideBar: HTMLElement | null | undefined;
  @HostBinding('class.fieldNavigatorSidebarVisible') fieldNavigatorSidebarVisible: boolean = false;
  public width: number;
  constructor() {
    this.width = 480;
  }

  ngOnInit(): void {
    this.modal = document.getElementById('form-field-information-modal');
    this.mainCanvas = document.getElementById('mainCanvas');
    this.fieldNavigatorSideBar = document.getElementById('fieldNavigatorSidebar');
    this.setFormFieldPosition();
  }

  private setFormFieldPosition() {
    if (this.modal && this.fieldNavigatorSideBar) {
      const fieldNavigatorSideBarRect = this.fieldNavigatorSideBar.getBoundingClientRect();

      if (this.mainCanvas) {
        if (fieldNavigatorSideBarRect.width > 0) {
          this.modal.style.top = `${fieldNavigatorSideBarRect.top + 50}px`;
          this.modal.style.left = `${fieldNavigatorSideBarRect.left + 8}px`;
          this.modal.style.width = `${fieldNavigatorSideBarRect.width - 15}px`;
        }
      }
    }
  }
}

